import { render, staticRenderFns } from "./Partnership.vue?vue&type=template&id=5bd0a4c4"
import script from "./Partnership.vue?vue&type=script&lang=ts"
export * from "./Partnership.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports